import { render, staticRenderFns } from "./TrialBalanceReport.vue?vue&type=template&id=196552f1"
import script from "./TrialBalanceReport.vue?vue&type=script&lang=js"
export * from "./TrialBalanceReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports